import React from 'react'

const IconYoutube = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path
                d='M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.00001 6.00193C5.99965 5.88362 6.03078 5.76734 6.09021 5.66504C6.14964 5.56274 6.23523 5.4781 6.33818 5.4198C6.44113 5.3615 6.55774 5.33165 6.67604 5.33332C6.79434 5.33498 6.91007 5.3681 7.01134 5.42926L10.3427 7.42726C10.4418 7.48637 10.524 7.57023 10.581 7.67061C10.638 7.771 10.668 7.88448 10.668 7.99993C10.668 8.11539 10.638 8.22886 10.581 8.32925C10.524 8.42963 10.4418 8.51349 10.3427 8.5726L7.01134 10.5706C6.91002 10.6318 6.79423 10.6649 6.67587 10.6665C6.55752 10.6682 6.44086 10.6383 6.33789 10.5799C6.23491 10.5215 6.14934 10.4368 6.08996 10.3344C6.03058 10.232 5.99953 10.1156 6.00001 9.99726V6.00193Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconYoutube
